import type { FaireProductEntity } from "../../entity_types/product";

export const p_8t2dmma33x: FaireProductEntity = {
  token: "p_8t2dmma33x",
  type: "product",
  name: "Mindful Minute",
  brandToken: "b_djgzg75ijy",
  brandName: "Open The Joy",
  imageUrl:
    "https://cdn.faire.com/fastly/b799078e58f767540cc18074812cf52c20e502c6338d36e95f9ff36a13ffa2bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b6bb23582509796bb4f309d124e19c62c4e2c1b09a95894c23c8950d037ca96.jpeg",
    "https://cdn.faire.com/fastly/79496b61350a1bec3e6daf3c7b96e17f7b676af344dccc66f04f879e95ef2f22.jpeg",
    "https://cdn.faire.com/fastly/15e221d790d27fd24c75e4b6450ad6b771b8d41230f820d6aa1600e0635286df.jpeg",
    "https://cdn.faire.com/fastly/e566e5b961010e1bc9168c55bc6039b8d8320faeee672bd6c35afe853abc3483.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "60 seconds is all it takes to settle big emotions and pacify hectic moments with Open The Joy's Mindful Minute Cards. Each card teaches a simple calming activity such as yoga poses, rhythmic breathing and grounding exercises, each accompanied by an uplifting quote to keep kids feeling cool, calm and confident. Designed for convenience, the set includes a 1-minute sand timer and a carabiner ring to keep the cards organized and ready for on-the-go practice. Perfect for busy families looking to incorporate quick, positive pauses into their daily routine, these cards prove that a minute of mindfulness can make all the difference in a child's mood and mindset.\n\nIncludes a 60 second timer, over 40 cards and a clip-and-go ring\nDesigned by child life experts\nThe perfect pocket-sized peacekeeper\nGreat gift for families and kids ages 3 and up\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:00.350Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
